var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"avatar",attrs:{"src":("https://crafthead.net/helm/" + _vm.key + "/8"),"alt":_vm.$t('avatar', { name: _vm.name }),"title":_vm.title ? _vm.$t('avatar', { name: _vm.name }) : ''},on:{"error":_vm.replaceWithDefault}})}
var staticRenderFns = []

export { render, staticRenderFns }